
import Vue from 'vue'
import router from "./router";
import App from './App.vue'

import MaterialKit from "./plugins/material-kit";

Vue.config.productionTip = false;

Vue.use(MaterialKit);

const Navbar = {
  showNavbar: false
};

Vue.mixin({
  data() {
    return {
      Navbar
    };
  }
});

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");